export default "__VITE_ASSET__6d1aa033__"